import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import ProductCard from './ProductCard';
import { useLocale } from '../context/LocaleContext';

const ProductRail = ({ title, products, seeAllLink }) => {
  const ref = useRef(null);
  const { t } = useLocale();
  const scroll = (dir) => {
    if (ref.current) ref.current.scrollBy({ left: dir * 600, behavior: 'smooth' });
  };

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-8 my-12">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="text-2xl md:text-3xl font-black tracking-tight">{title}</h2>
          <div className="h-1 w-14 bg-[#22c55e] mt-2"></div>
        </div>
        <div className="flex items-center gap-2">
          {seeAllLink && <Link to={seeAllLink} className="text-xs font-bold tracking-wider text-[#22c55e] hover:underline">{t('viewAll')}</Link>}
          <button onClick={() => scroll(-1)} className="w-9 h-9 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 transition"><ChevronLeft size={18} /></button>
          <button onClick={() => scroll(1)} className="w-9 h-9 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 transition"><ChevronRight size={18} /></button>
        </div>
      </div>
      <div ref={ref} className="flex gap-4 overflow-x-auto scroll-smooth pb-3 [&::-webkit-scrollbar]:hidden" style={{ scrollbarWidth: 'none' }}>
        {products.map((p) => (
          <div key={p.id} className="min-w-[220px] md:min-w-[240px] max-w-[240px]">
            <ProductCard product={p} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductRail;
